import React from 'react';

function DonutChart({ data, title, colors, icon: Icon }) {
  if (!data || Object.keys(data).length === 0) return null;
  const total = Object.values(data).reduce((a, b) => a + b, 0);
  if (total === 0) return null;
  const entries = Object.entries(data);
  let cumulative = 0;
  const segments = entries.map(([label, count]) => {
    const pct = count / total; const start = cumulative; cumulative += pct;
    return { label, count, pct, start };
  });
  const r = 52, cx = 70, cy = 70;
  return (
    <div className="n-chart-card">
      <div className="n-chart-header">{Icon && <Icon size={14} />}<span>{title}</span>}</div>
      <div className="n-donut-wrap">
        <svg viewBox="0 0 140 140" className="n-donut-svg" role="img" aria-labelledby={`donut-title-${title}`}>
          <title id={`donut-title-${title}`}>{title} — 총 {total}건</title>
          {segments.map((seg, i) => {
            const circ = 2 * Math.PI * r, dash = seg.pct * circ, gap = circ - dash;
            const offset = -seg.start * circ - circ * 0.25;
            const color = colors?.[seg.label] || 'var(--cat-ops)';
            return <circle key={i} cx={cx} cy={cy} r={r} fill="none" stroke={color} strokeWidth={18} strokeDasharray={`${dash} ${gap}`} strokeDashoffset={offset} />;
          })}
          <text x={cx} y={cy - 4} textAnchor="middle" fill="var(--txt)" fontSize="22" fontWeight="700">{total}</text>
          <text x={cx} y={cy + 12} textAnchor="middle" fill="var(--txt3)" fontSize="11">전체</text>
        </svg>
        <div className="n-donut-legend">
          {segments.map((seg, i) => (
            <div key={i} className="n-legend-row">
              <span className="n-legend-dot" style={{ background: colors?.[seg.label] || 'var(--cat-ops)' }} />
              <span className="n-legend-name">{seg.label}</span>
              <span className="n-legend-val">{seg.count}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export { DonutChart };
